import { GeoSearch } from '@aloft/toolkit-shared';
import { Block, Flex, IconButton, Input, RadioGroup, Typography } from '@aloft/toolkit-sui';

import polygonToolIcon from '../../../../assets/icons/polygon-tool.svg';

const PROXIMITY_OVERLAY_SHADOW =
  '0px 0px 4px 0px rgba(0,0,0,0.08), 0px 8px 8px 0px rgba(0,0,0,0.16)';

type ProximityFilterOverlayProps = {
  geoSearch: GeoSearch;
  radius: '' | number | undefined;
  onRadiusChange: (value: '' | number | undefined) => void;
  onRadiusClear: () => void;
  onGeoSearchTypeChange: (value: string) => void;
  onPolygonClear: () => void;
};

export const ProximityFilterOverlay = ({
  geoSearch,
  radius,
  onRadiusChange,
  onRadiusClear,
  onGeoSearchTypeChange,
  onPolygonClear,
}: ProximityFilterOverlayProps) => {
  const isRadius = geoSearch.t === 'radius';
  const isPolygon = geoSearch.t === 'polygon';
  const hasPolygon = isPolygon && geoSearch.coords.length > 0;
  const isDrawingPolygon = isPolygon && !hasPolygon;

  return (
    <Flex
      position="absolute"
      bottom="12px"
      left="12px"
      zIndex={4}
      __dangerDoNotUseSx={{ pointerEvents: 'auto' }}
    >
      <Block
        backgroundColor="surface1"
        padding="8px"
        borderRadius="8px"
        boxShadow={PROXIMITY_OVERLAY_SHADOW}
      >
        <Flex flexDirection="column">
          <Flex alignItems="center" gap="4px">
            <RadioGroup
              value={geoSearch.t}
              items={[{ value: 'radius', label: 'Radius' }]}
              size="sm"
              textVariant={isRadius ? 'h4' : 'body1'}
              gap="0"
              fullWidth={false}
              onChange={onGeoSearchTypeChange}
            />
            <Block width="36px" height="32px" flexShrink={0}>
              <Input
                type="number"
                size="sm"
                id="proximity-filter-radius"
                min={0}
                max={100}
                clearable={false}
                value={radius}
                onChange={onRadiusChange}
                onClear={onRadiusClear}
                __dangerDoNotUseSx={{
                  height: '32px',
                  paddingInline: '8px',
                  textAlign: 'center',
                }}
              />
            </Block>
            <Typography variant="body2">mi</Typography>
          </Flex>
          <Flex alignItems="center" gap="8px">
            <RadioGroup
              value={geoSearch.t}
              items={[{ value: 'polygon', label: 'Polygon' }]}
              size="sm"
              textVariant={isPolygon ? 'h4' : 'body1'}
              gap="0"
              fullWidth={false}
              onChange={onGeoSearchTypeChange}
            />
            {hasPolygon && (
              <IconButton
                ariaLabel="Clear polygon"
                variant="tertiary"
                icon="delete-bin"
                iconColor="textError"
                iconSize="md"
                size="xs"
                onClick={onPolygonClear}
                __dangerDoNotUseSx={{ height: '16px', width: '16px', minWidth: '16px', padding: 0 }}
              />
            )}
            {isDrawingPolygon && (
              <Block width="16px" height="16px" flexShrink={0} overflow="hidden">
                <img
                  src={polygonToolIcon}
                  alt=""
                  width={16}
                  height={16}
                  style={{ display: 'block', width: '100%', height: '100%' }}
                />
              </Block>
            )}
          </Flex>
        </Flex>
      </Block>
    </Flex>
  );
};
